import parseISO from 'date-fns/parseISO'

export const getOrdinalPostfix = num => {
  const cent = num % 100
  if (cent >= 10 && cent <= 20) return 'th'
  const dec = num % 10
  if (dec === 1) return 'st'
  if (dec === 2) return 'nd'
  if (dec === 3) return 'rd'
  return 'th'
}

export const sortGames = (a, b) =>
  parseISO(b.event.date) - parseISO(a.event.date)

export const computeWinPercentage = ({ w, l, t }) => {
  const percentage = +((w + t * 0.5) / (w + t + l)).toFixed(2)
  return isNaN(percentage) ? 0 : percentage
}

export const getTeamGamesResults = games =>
  games.reduce((acc, match) => {
    const { winnerId, tie } = match
    const isMatchEnded = !!winnerId || tie
    const keys = ['team1', 'team2']
    keys.forEach(key => {
      const isTie = isMatchEnded && tie ? 1 : 0
      const isWinner = match.winnerId === match[key].id ? 1 : 0
      const isLoser =
        isMatchEnded && match.winnerId !== match[key].id && !isTie ? 1 : 0
      const existingTeam = acc[match[key].id]
      acc[match[key].id] = {
        id: match[key].id,
        name: match[key].name,
        results: {
          w: isWinner + (existingTeam ? existingTeam.results.w : 0),
          l: isLoser + (existingTeam ? existingTeam.results.l : 0),
          t: isTie + (existingTeam ? existingTeam.results.t : 0),
        },
        matches: isMatchEnded
          ? existingTeam
            ? [...existingTeam.matches, match]
            : [match]
          : existingTeam
            ? existingTeam.matches
            : [],
        futureMatches: !isMatchEnded
          ? existingTeam
            ? [...existingTeam.futureMatches, match]
            : [match]
          : existingTeam
            ? existingTeam.futureMatches
            : [],
      }
    })
    return acc
  }, {})

export const mapGamesToTeams = (teams, teamGamesResults) =>
  teams
    .map(team => {
      const teamResults = teamGamesResults[team.id]
      if (teamResults) {
        return {
          ...teamResults,
          winPercentage: computeWinPercentage(teamResults.results),
          ...team,
        }
      } else {
        return {
          ...team,
          matches: [],
          futureMatches: [],
          winPercentage: 0,
          results: {
            w: 0,
            l: 0,
            t: 0,
          },
        }
      }
    })
    .sort((team1, team2) => team2.winPercentage - team1.winPercentage)

const storeGameWithScores = (game, key, map) => {
  const storedGame = map.get(key)
  const gameHasScores = game.score1 != null && game.score2 != null
  const storedGameHasScores =
    storedGame.score1 != null && storedGame.score2 != null
  if (gameHasScores && !storedGameHasScores) {
    map.set(key, game)
  }
}

const compareGames = map => game => {
  const { event, team1, team2 } = game
  const key = event.date + team1.id + team2.id
  const mirroredKey = event.date + team2.id + team1.id
  const existingKey = map.has(key)
    ? key
    : map.has(mirroredKey)
      ? mirroredKey
      : false

  if (existingKey) {
    storeGameWithScores(game, existingKey, map)
  } else {
    map.set(key, game)
  }
}

const getUniqueGames = games => {
  const uniqGamesMap = new Map()
  games.forEach(compareGames(uniqGamesMap))
  return Array.from(uniqGamesMap, ([_, value]) => value)
}

export const getTeamLeagueResults = (games, teams) => {
  const uniqGames = getUniqueGames(games)
  const teamGamesResults = getTeamGamesResults(uniqGames)
  return mapGamesToTeams(teams, teamGamesResults)
}

export const getOverallTeamResult = league => {
  const teamLeagueResults = getTeamLeagueResults(league.matches, league.teams)
  return {
    id: league.id,
    name: league.name,
    results: teamLeagueResults,
  }
}
